const setLabelFrequency = {
  onDemand: 'ON DEMAND',
  month: 'month',
  months: 'months',
  day: 'day',
  days: 'days'
}

export default setLabelFrequency;
